var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPetrolCars = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 84 72"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 68,
  cy: 16,
  r: 16,
  fill: "#58D5A7"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M66.8 21.82v-4.1h2.23c2.61 0 4.38-1.63 4.38-4.05 0-2.41-1.77-4.07-4.38-4.07h-4.75v12.22h2.51zm0-6.2v-3.89h2c1.24 0 1.99.85 1.99 1.95 0 1.09-.73 1.94-2 1.94h-2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#1D1D1B",
  fillRule: "evenodd",
  d: "m36.43 24 14.55 9.33h5.35l5 5.4v10.6h-4V40.3l-2.75-2.97H15.22l-3.27-5.14-5.28 3.27v13.87h-4v-16.1L17.56 24zm-20.68 5.83 2.08 3.5h6.73V28H18.7zm27.82 3.5H28.56V28h6.7zM10 48a6 6 0 1 1 12 0 6 6 0 0 1-12 0m8 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0m30-6a6 6 0 1 0 0 12 6 6 0 0 0 0-12m0 4a2 2 0 1 1 0 4 2 2 0 0 1 0-4m-9.33-.67H25.33v4h13.34z",
  clipRule: "evenodd"
})));
export { SvgPetrolCars as ReactComponent };
export default new URL("/home/runner/_work/motorway-seller-webapp/motorway-seller-webapp/src/client/assets_seller/ulez/petrol-cars.svg", import.meta.url).toString();